<template>
  <span>
    <b-button :variant="buttonVariant" :class="buttonClass" :disabled="disabled" @click="$refs.date.dp.toggle()">
      <slot>
        {{ date }} 
      </slot>
    </b-button>
    <datetime class="am-datepicker" ref="date" v-model="date" :config="config" @dp-show="bindClickOutside" @dp-hide="unbindClickOutside" />
  </span>
</template>

<style>
  input.am-datepicker {
    display: none;
  }
</style>

<script>
  import Datetime from 'vue-bootstrap-datetimepicker'

	export default {
    props: {
      value: String,
      config: {
        type: Object,
        default() {
          return {
            locale: window.lang,
            format: 'YYYY-MM-DD',
            showTodayButton: true,
          }
        }
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      buttonVariant: {
        type: String,
        default: 'link',
      },
      buttonClass: {
        type: String,
        default: 'text-dark p-0',
      },
    },
    components: {
      Datetime,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        lang: window.lang,
        date: this.value,
      }
    },
    watch: {
      value() {
        this.date = this.value
      },
      date() {
        this.$emit('input', this.date)
      }
    },
    methods: {
      bindClickOutside() {
        setTimeout(() => {
          this.$refs.date.$el.addEventListener('click', this.stopProp)
          document.body.addEventListener('click', this.onClickOutside)
        }, 50)
      },
      unbindClickOutside() {
        this.$refs.date.$el.removeEventListener('click', this.stopProp)
        document.body.removeEventListener('click', this.onClickOutside)
      },
      onClickOutside() {
        this.unbindClickOutside()
        this.$refs.date.dp.hide()
      },
      stopProp(e) {
        e.stopPropagation()
      },
    },
  }
</script>